// src/pages/agency/AgencyRoot.jsx

import React from 'react'
import { Box, Paper, Tab, Tabs } from '@mui/material'
import { Link, Outlet } from 'react-router-dom'
import routes from '../../Config/routes'
import { globalStyles } from '../../Utils/Styles'
import { useRouteMatch } from '../../Hooks/useRouteMatch'
import useIsDesktop from '../../Hooks/useIsDesktop'

const tabData = [
  {
    name: 'Home',
    route: routes.agency,
    value: routes.agency
  },
  {
    name: 'Creators',
    route: routes.agencyCreators,
    value: `${routes.agencyCreators}/*`
  },
  {
    name: 'Sales',
    route: routes.agencySales,
    value: `${routes.agencySales}/*`
  }
]

export default function AgencyRoot() {
  // match Home, Creators or Sales
  const routeMatch = useRouteMatch([
    routes.agency,
    `${routes.agencyCreators}/*`,
    `${routes.agencySales}/*`
  ])
  const currentTab = routeMatch?.pattern?.path
  const isDesktop = useIsDesktop()

  return (
    <Box sx={{ ...globalStyles.wholeHeightMinusToolbar }}>
      <Paper
        square
        elevation={4}
        sx={{
          ...globalStyles.stickyTopMinusToolbar,
          paddingInline: { xs: 0, md: 2 },
          position: 'sticky',
          left: 0,
          zIndex: theme => theme.zIndex.appBar - 1
        }}
      >
        <Tabs value={currentTab} centered={isDesktop}>
          {tabData.map(entry => (
            <Tab
              key={entry.route}
              label={entry.name}
              value={entry.value}
              to={entry.route}
              component={Link}
            />
          ))}
        </Tabs>
      </Paper>

      {/* renders Home, Creators or Sales via your router config */}
      <Outlet />
    </Box>
  )
}
